import type { Organization } from '@/features/organizations/services/schemas.ts';
import { Link } from '@tanstack/react-router';
import { ArrowRight, Building2, MapPin } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { useSupplyPoint } from '@/features/supply-points/context/useSupplyPoint';

export function OrgCard({ org }: { org: Organization }) {
  const { supplyPoints } = useSupplyPoint();
  const supplyPointCount = supplyPoints.filter((sp) =>
    sp.partners.some((p) => p.id === org.id)
  ).length;

  return (
    <Link
      to="/organizations/$organizationId"
      params={{ organizationId: org.id }}
      className="group text-left rounded-2xl border border-border bg-card p-5 hover:border-primary/40 hover:shadow-sm transition-all flex flex-col"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex size-11 items-center justify-center rounded-xl bg-primary/10 shrink-0 group-hover:bg-primary/15 transition-colors">
            <Building2 size={20} className="text-primary" />
          </div>
          <div className="min-w-0">
            <div className="font-semibold text-foreground truncate">{org.name}</div>
            {(org.city || org.country) && (
              <div className="text-xs text-muted-foreground mt-0.5 flex items-center gap-1">
                <MapPin size={11} />
                {[org.city, org.country].filter(Boolean).join(', ')}
              </div>
            )}
          </div>
        </div>
        <ArrowRight
          size={16}
          className="text-muted-foreground/40 group-hover:text-primary transition-colors shrink-0 mt-1"
        />
      </div>

      <div className="flex items-center gap-4 text-sm text-muted-foreground mt-auto pt-3 border-t border-border">
        <div className="flex items-center gap-1.5">
          <MapPin size={13} className="text-muted-foreground/70" />
          <span>
            <span className="font-semibold text-foreground">{supplyPointCount}</span>{' '}
            <Trans>supply points</Trans>
          </span>
        </div>
      </div>
    </Link>
  );
}
